import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import smallArrow from 'assets/chevron-down-small.svg';
import newWindow from 'assets/new-window.svg';
import sourceTick from 'assets/source-tick.svg';
import tick from 'assets/tick.svg';

import { Button } from 'Components/Button';

import { trackEvent } from 'services/eventTracking';

import { POSITIVE_CATEGORIES, POSITIVE_FEEDBACK_SOURCE } from 'utlis/constants';

import styles from './styles.module.scss';

export const PositiveFinding = ({ data, selectedCategory }) => {
  const contentRef = useRef(null);

  const [height, setHeight] = useState('110px');
  const [isExpanded, setIsExpanded] = useState(false);

  const positiveCategoryKey = data?.positiveCategory;
  const relevantSource = selectedCategory === 'none'
    ? POSITIVE_FEEDBACK_SOURCE.ALL_TOPICS
    : (positiveCategoryKey ? POSITIVE_FEEDBACK_SOURCE[positiveCategoryKey?.toUpperCase()] : null);

  useEffect(() => {
    if (isExpanded) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    }
    else {
      setHeight('110px');
    }
  }, [isExpanded]);

  return (
    <div
      className={styles['positive-container']}
    >
      <div
        className={cn(
          styles['positive-findings'],
          { [styles['gradient']]: !isExpanded && contentRef?.current?.scrollHeight >= 130 }
        )}
        ref={contentRef}
        style={{
          height: contentRef?.current?.scrollHeight
        && contentRef.current.scrollHeight <= 130
            ? 'auto'
            : height,
        }}
      >
        {POSITIVE_CATEGORIES.map(section => (
          data[section.key]
          && data[section.key].length > 0
          && (selectedCategory === 'none' || positiveCategoryKey === section.key) && (
            <div key={section.key} className={styles['section']}>
              {selectedCategory === 'none' && (
                <p className={styles['title']}>
                  {section.title}
                </p>
              )}
              <div className={styles['feedback']}>
                {data[section.key].map(val => (
                  <div key={val} className={styles['row']}>
                    <img src={tick} alt="check-mark" className={styles['icon']} />
                    <p className={styles['text']}>
                      {val}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )
        ))}
        {relevantSource && (
          <div className={styles['column']}>
            <p className={styles['sub-heading']}>
              Source
            </p>
            <a
              href={relevantSource.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles['bar']}
            >
              <img src={sourceTick} alt="icon" />
              <p className={styles['article-name']}>
                {relevantSource.sourceName || 'Topics Checklists'}
              </p>
              <img src={newWindow} className={styles['open-icon']} alt="open-link" />
            </a>
          </div>
        )}
      </div>
      {contentRef?.current?.scrollHeight >= 130 && (
        <Button onClick={toggleExpand} className={cn(styles['button'], { [styles['margin-top']]: isExpanded })}>
          <img
            src={smallArrow}
            alt="small-arrow"
            className={cn(styles['arrow'], { [styles['point-up']]: isExpanded })}
          />
          {' '}
          {isExpanded ? 'See less' : 'See more'}
        </Button>
      )}
    </div>

  );

  function toggleExpand() {
    trackEvent(`[click] ${isExpanded ? '"See less"' : '"See more"'} button clicked for positive feedback`);
    setIsExpanded(!isExpanded);
  }
};

PositiveFinding.propTypes = {
  data: PropTypes.shape({
    typography: PropTypes.array,
    color: PropTypes.array,
    layoutAndHierarchy: PropTypes.array,
    sources: PropTypes.array,
    positiveCategory: PropTypes.string,
  }).isRequired,
  selectedCategory: PropTypes.string,
};
